import { useState, useEffect } from 'react'
import { getIDPProviders, buildIDPLoginUrl } from '../api/auth'
import type { IDPProvider } from '../types/auth'

export function useIDPProviders() {
  const [providers, setProviders] = useState<IDPProvider[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let isMounted = true

    async function fetchProviders() {
      try {
        setLoading(true)
        setError(null)
        const data = await getIDPProviders()
        if (isMounted) {
          setProviders(data.providers)
        }
      } catch (err) {
        if (isMounted) {
          setError('Unable to load sign-in options. Please try again.')
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchProviders()

    return () => {
      isMounted = false
    }
  }, [])

  const handleProviderLogin = (provider: IDPProvider) => {
    sessionStorage.setItem('idp_provider_key', provider.provider_key)
    window.location.href = buildIDPLoginUrl(provider.provider_key)
  }

  return {
    providers,
    loading,
    error,
    handleProviderLogin
  }
}
